module.exports = __webpack_public_path__ + "img/img46.0aa9d6aa.svg";